export default {
    mounted: (el, binding) => {
        el.addEventListener('input', function (e) {
            if (el._formatting) return;

            let value = e.target.value;

            value = value.replace(/[^\d.]/g, '');

            const parts = value.split('.');
            if (parts.length > 2) {
                value = parts[0] + '.' + parts.slice(1).join('');
            }

            if (parts.length === 2 && parts[1].length > 2) {
                value = parts[0] + '.' + parts[1].substring(0, 2);
            }

            e.target.value = value;

            if (value !== el._lastFormattedValue) {
                el._formatting = true;
                el._lastFormattedValue = value;
                el.dispatchEvent(new Event('input', { bubbles: true }));
                el._formatting = false;
            }
        });
    },
};
